import React, { useState, useContext, createContext } from "react";
const authContext = createContext();

export function ProvideAuth({ user, children }) {
    const auth = useProvideAuth(user);
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
    return useContext(authContext);
};

function useProvideAuth(initialState) {
    const [user, setUser] = useState(initialState);

    const signIn = (email, password, successCallback, finishCallback) => {
        const formData = new FormData();
        formData.append('username', email);
        formData.append('password', password);

        return fetch('/rest/login-check', {
            method: 'POST',
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            body: formData
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.data && result.data.user) {
                        setUser(result.data.user);
                        successCallback();
                    } else {
                        finishCallback(result);
                    }
                }
            );
    };

    const signOut = () => {
        return fetch('/logout', {
            method: 'POST',
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            redirect: "manual",
        })
            .then(() => {
                setUser(false);
                window.location.href = '/';
            });
    };

    return {
        user,
        signIn,
        signOut,
        setUser,
    };
}
